module.exports = __webpack_public_path__ + "img/8.9b39a955.jpg";